module.exports = __webpack_public_path__ + "static/media/icon_16.7b69da5a.svg";